import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService, Result } from '@shared/data-access';
import { DailyReportsResponse, SummaryReportsResponse } from '../models/reports.models';
import { TableDataResponse } from '@shared/ui/tables';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseReportsService {
  constructor(protected api: BaseApiService) {}

  abstract fetchDailyReports(query: string): Observable<Result<TableDataResponse<DailyReportsResponse>>>;
  abstract fetchSummaryReports(query: string): Observable<Result<TableDataResponse<SummaryReportsResponse>>>;
}
